import { render, staticRenderFns } from "./RestoreDialog.vue?vue&type=template&id=063e82d4&scoped=true&"
import script from "./RestoreDialog.vue?vue&type=script&lang=js&"
export * from "./RestoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./RestoreDialog.vue?vue&type=style&index=0&id=063e82d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e82d4",
  null
  
)

export default component.exports